import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducer';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export enum ViewMode {
  cards = 'cards',
  reports = 'reports',
}

export enum Language {
  en = 'EN',
  he = 'HE',
}

export const DefaultLanguage = {
  en: 'English',
  he: 'Hebrew',
} as const;

export interface LayoutState {
  viewMode: keyof typeof ViewMode;
  lang: string;
}

const initialState: LayoutState = {
  viewMode: ViewMode.cards,
  lang: Language.en,
};

export const { actions, reducer } = createSlice({
  name: 'layout',
  initialState,
  reducers,
});

export const { changeViewMode, changeLanguage } = actions;

const persistConfig = {
  key: 'layout',
  version: 1,
  storage,
};

export const persistReducerLayout = persistReducer(persistConfig, reducer);
